import React, {Component, Fragment} from 'react';
import {connect} from "react-redux";
import {IRootState} from "../../../store";
import DispatchProps from "../../../utils/DispatchProps";
import School from "../../../models/School";
import Actions from "../../../redux/Actions";
import ApiService from "../../ApiService";
import H from "history";
import SdsSubject from "../../../models/SdsSubject";
import {
    SubjectExcludes,
} from "../../../models/SchoolWorkloadConfig";
import {
    MessageBarType,
} from "office-ui-fabric-react";
import OnboardNavigation from "../onboard/OnboardNavigation";
import OnboardTimeline, {OnboardTimelineItem} from "../onboard/OnboardTimeline";
import SyncSubjectsAndYearsPrompt from "../../SyncSubjectsAndYearsPrompt";
import SubjectMergeEditor from "../../SubjectMergeEditor";
import {SubjectMerge} from "../../../models/SubjectMerge";
import HelpBox from "../admin/HelpBox";

interface OnboardSubjectMergePageProps {
    tenantId: string;
    schoolCode: string;

    apiService: ApiService;
    history: H.History;
}

interface OnboardSubjectMergePageState {
    school?: School;
    subjectMerges?: SubjectMerge[];
    subjectExcludes?: SubjectExcludes;
    sdsSubjects?: SdsSubject[];
}

class OnboardSubjectMergePage extends Component<OnboardSubjectMergePageProps & DispatchProps ,OnboardSubjectMergePageState> {
    static displayName = OnboardSubjectMergePage.name;
    
    constructor(props: OnboardSubjectMergePageProps & DispatchProps) {
        super(props);

        this.state = {
            subjectMerges: undefined,
            subjectExcludes: undefined,
            sdsSubjects: undefined,
        };

    }
    
    async componentDidMount() {
        if(this.props.tenantId && this.props.schoolCode)
        {
            await this.load();
            
            const schoolWorkloadConfig = await this.props.apiService.getSchoolConfigJson(this.props.tenantId,this.props.schoolCode);
            const subjectMerges = await this.props.apiService.getSubjectMergesForSchool(this.props.tenantId,this.props.schoolCode);
            const sdsSubjects = await this.props.apiService.getSdsSubjectsForSchool(this.props.tenantId,this.props.schoolCode);
            this.setState({
                subjectExcludes: schoolWorkloadConfig.subjectExcludes,
                subjectMerges,
                sdsSubjects
            });
        }

    }

    async componentDidUpdate(prevProps: Readonly<OnboardSubjectMergePageProps & DispatchProps>, prevState: OnboardSubjectMergePageState): Promise<void> {

        if (this.props.tenantId !== prevProps.tenantId || this.props.schoolCode !== prevProps.schoolCode) {
            await this.load();
        }
        
    }

    private async load(): Promise<void> {
        var school = await this.props.apiService.getSchool(this.props.tenantId, this.props.schoolCode)

        this.setState({
            school
        });
    }

    private saveMerges = async () => {
        if (this.state.subjectMerges === undefined) {
            return false;
        }
        
        const savedSubjectMerges = await this.props.apiService.putSubjectMergesForSchool(this.props.tenantId, this.props.schoolCode, this.state.subjectMerges);
        await this.props.dispatch(Actions.showMessageBar("Saved subject merges to config",MessageBarType.success));

        this.setState({
            subjectMerges: savedSubjectMerges
        });

        return true;
    }

    render() {
        
        let subjectMergeEditor: React.ReactElement | undefined = undefined;
        if(this.state.subjectMerges !== undefined && this.state.sdsSubjects !== undefined)
        {
            subjectMergeEditor = (
                <SubjectMergeEditor onMergesChanged={
                    (subjectMerges) => {
                        this.setState({subjectMerges: subjectMerges});
                    }}
                    sdsSubjects={this.state.sdsSubjects}
                    subjectMerges={this.state.subjectMerges}
                    subjectExcludes={this.state.subjectExcludes}
                />
            );
        }
        
        const helpBoxText = <Fragment>
            <b>Please group together duplicates</b><br/><br/>
            You can remove or rename them later.
        </Fragment>
        
        return (
            <Fragment>
                
                {this.state.school ? <SyncSubjectsAndYearsPrompt school={this.state.school} message={"SyncSubjectsAndYears must have completed for unmerged subjects to appear."}/> : null }
                
                <HelpBox
                    TitleText={"Your school data may contain duplicate subjects."}
                    HelpBoxText={helpBoxText}
                    Icon={"MergeDuplicate"}
                />

                <OnboardTimeline tenantId={this.props.tenantId} schoolCode={this.props.schoolCode} apiService={this.props.apiService}>
                    {(school: School,timelineItems: OnboardTimelineItem[]) => {
                        return (
                            <Fragment>
                                {subjectMergeEditor}
                                <OnboardNavigation currentTimelineItemKey={"subject-merge"} timelineItems={timelineItems} completeItem={this.saveMerges} enableNext={true} enableSave={true} history={this.props.history} tenantId={this.props.tenantId} schoolCode={this.props.schoolCode} />
                            </Fragment>
                        );
                    }}
                </OnboardTimeline>
              </Fragment>
        );
    }
}

export default connect(
    (state: IRootState, ownProps: any): OnboardSubjectMergePageProps => {
        return {
            tenantId: ownProps.match.params.tenantId,
            schoolCode: ownProps.match.params.schoolCode,
            apiService: state.auth.apiService,
            history: ownProps.history,
        };
    }
)(OnboardSubjectMergePage)